export default {
      id: "done-rounded-circle-fill-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#done-rounded-circle-fill",
      toString: function () {
        return this.url;
      }
    }